module.exports = __webpack_public_path__ + "img/cog.376b2db6.svg";